/*
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.09961C17.4676 2.09961 21.9004 6.53238 21.9004 12C21.9004 17.4676 17.4676 21.9004 12 21.9004C6.53238 21.9004 2.09961 17.4676 2.09961 12C2.09961 6.53238 6.53238 2.09961 12 2.09961ZM12 3.90039C7.52649 3.90039 3.90039 7.52649 3.90039 12C3.90039 16.4735 7.52649 20.0996 12 20.0996C16.4735 20.0996 20.0996 16.4735 20.0996 12C20.0996 7.52649 16.4735 3.90039 12 3.90039Z" fill="#36364D"/>
</svg>
*/

export const UnCheckedSvg = (props: {
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
}) => {
  const { onClick } = props
  return (
    <div onClick={onClick}>
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M12 2.09961C17.4676 2.09961 21.9004 6.53238 21.9004 12C21.9004 17.4676 17.4676 21.9004 12 21.9004C6.53238 21.9004 2.09961 17.4676 2.09961 12C2.09961 6.53238 6.53238 2.09961 12 2.09961ZM12 3.90039C7.52649 3.90039 3.90039 7.52649 3.90039 12C3.90039 16.4735 7.52649 20.0996 12 20.0996C16.4735 20.0996 20.0996 16.4735 20.0996 12C20.0996 7.52649 16.4735 3.90039 12 3.90039Z'
          fill='#36364D'
        />
      </svg>
    </div>
  )
}
